// https://github.com/remarkjs/react-markdown/blob/main/changelog.md#remove-buggy-html-in-markdown-parser
import ReactMarkdown from 'react-markdown';

import { trackedLazy, TrackedSuspense } from '#src/lib/tracked-lazy';

import { enhance } from '../Markdown/enhancers';

// Markdown only treats `<` as HTML when a letter, `/`, `!` or `?` follows it
// (tags, closing tags, comments, declarations). Without one, rehype-raw
// changes nothing, so plain react-markdown renders the same output.
const HTML_PATTERN = /<[a-z/!?]/i;

// Missing text (an optional content field) has no HTML either; anything else
// that isn't a string might, so it goes through rehype-raw.
const containsHtml = (children) => {
  if (children == null) return false;
  return typeof children === 'string' ? HTML_PATTERN.test(children) : true;
};

const MarkdownRawHtml = trackedLazy(() => import('./markdown-raw-html'));

const withRawHtml = (sanitize) =>
  function Markdown(props) {
    if (!containsHtml(props.children)) return <ReactMarkdown {...props} />;

    return (
      <TrackedSuspense fallback={null}>
        <MarkdownRawHtml {...props} sanitize={sanitize} />
      </TrackedSuspense>
    );
  };

export const MarkdownWithHtml = enhance(withRawHtml(false));

export const MarkdownWithSanitizedHtml = enhance(withRawHtml(true));

export default MarkdownWithHtml;
